import React, { useEffect } from 'react';
import feather from 'feather-icons';
import { Link } from 'react-router-dom';

function Header() {
    useEffect(() => {
        feather.replace();
    }, []);
    return (
        <header className="section-t-space header-bg">
            <div className="custom-container">
                <div className="header-panel">
                    <Link
                        className="sidebar-btn icon-btn"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasLeft"
                        to="#"
                    >
                        <i className="menu-icon" data-feather="menu"></i>
                    </Link>

                    <div className="header-center">
                        <img
                            className="logo-white"
                            src={'/assets/images/logo/coin_white.png'}
                            alt="logo"
                        />
                        <span className="xpenso-text">Xpenso</span>
                    </div>

                    <Link to="/notification" className="notification icon-btn">
                        <i className="notification-icon" data-feather="bell"></i>
                    </Link>
                </div>
            </div>
        </header>
    );
}

export default Header;
